import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;
import Link from 'next/link';
import styled from 'styled-components';
import * as ds from '@bob/design-system';
import * as url from '@bob/url';
import * as utils from '@bob/utils';
export function TagList(_ref) {
  var context = _ref.context,
      tagList = _ref.tagList;
  return __jsx(TagContainer, null, tagList.map(function (tag) {
    return __jsx(Link, {
      href: getTagHref(context, tag),
      key: tag.slug,
      prefetch: false,
      scroll: true
    }, __jsx("a", null, __jsx(ds.Tag, {
      variant: "outlined"
    }, tag.name)));
  }));
}

function getTagHref(context, tag) {
  switch (context) {
    case 'article':
      {
        if (tag.kind === 'category') {
          return url.products({
            params: _defineProperty({}, tag.kind, tag.slug)
          }).path;
        }

        return url.tag({
          name: tag.name,
          slug: tag.slug
        }).path;
      }

    case 'brand':
      {
        if (!tag.kind) {
          return url.brands({
            searchableTag: utils.text.slugify(tag.name, ' ')
          }).path;
        }

        return url.products({
          params: _defineProperty({}, tag.kind, tag.slug)
        }).path;
      }

    case 'product':
      {
        if (!tag.kind) return url.products({
          params: {
            searchableTag: utils.text.slugify(tag.name, ' ')
          }
        }).path;
        return url.products({
          params: _defineProperty({}, tag.kind, tag.slug)
        }).path;
      }
  }
}

var TagContainer = styled.div.withConfig({
  displayName: "TagList__TagContainer",
  componentId: "sc-1vpin2q-0"
})(["align-items:center;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;max-width:340px;margin:0px auto 80px;", "{margin:5px;}"], ds.Tag);